import { connect } from "react-redux";
import ChatsFilter from "./ChatsFilter";

const mapState = ({ chats }) => ({
  chatsFilterVal: chats.chatsFilterVal,
});
export default connect(mapState)(ChatsFilter);
